import React from "react";

export const Image = ({ title, largeImage, smallImage, onOpen }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a
          href={largeImage}
          title={title}
          data-lightbox-gallery="gallery1"
          onClick={(e) => {
            if (onOpen) {
              e.preventDefault();
              onOpen();
            }
          }}
        >
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img
            src={smallImage}
            className="img-responsive"
            alt={title}
            loading="lazy"
            decoding="async"
          />{" "}
        </a>{" "}
      </div>
    </div>
  );
};
